import { CompensationProductsActions } from 'src/store/actions/compensationProductsActions';
import Utils from 'src/utils';
const toOptions = (comments) => comments.map(({ Id, Name }) => ({ label: Name || '', value: Id }));
const initialState = {
    list: [],
    options: [],
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CompensationProductsActions.GET_COMPENSATION_PRODUCTS_LIST_REQUEST:
        case CompensationProductsActions.POST_COMPENSATION_PRODUCT_REQUEST:
        case CompensationProductsActions.PUT_COMPENSATION_PRODUCT_REQUEST:
        case CompensationProductsActions.DELETE_COMPENSATION_PRODUCT_REQUEST: {
            return {
                ...state,
                loading: true
            };
        }
        case CompensationProductsActions.GET_COMPENSATION_PRODUCTS_LIST_SUCCESS: {
            return {
                ...state,
                list: payload,
                options: toOptions(payload),
                loading: false
            };
        }
        case CompensationProductsActions.POST_COMPENSATION_PRODUCT_SUCCESS: {
            const compensations = [...state.list, payload];
            return {
                ...state,
                list: compensations,
                options: toOptions(compensations),
                loading: false
            };
        }
        case CompensationProductsActions.PUT_COMPENSATION_PRODUCT_SUCCESS: {
            const compensations = Utils.arrays.mergeWithNestedObjectsReplace(state.list, [payload], 'Id');
            return {
                ...state,
                list: compensations,
                options: toOptions(compensations),
                loading: false
            };
        }
        case CompensationProductsActions.DELETE_COMPENSATION_PRODUCT_SUCCESS: {
            const compensations = state.list.filter(({ Id }) => Id !== payload.Id);
            return {
                ...state,
                list: compensations,
                options: toOptions(compensations),
                loading: false
            };
        }
        case CompensationProductsActions.GET_COMPENSATION_PRODUCTS_LIST_FAIL:
        case CompensationProductsActions.POST_COMPENSATION_PRODUCT_FAIL:
        case CompensationProductsActions.PUT_COMPENSATION_PRODUCT_FAIL:
        case CompensationProductsActions.DELETE_COMPENSATION_PRODUCT_FAIL: {
            return {
                ...state,
                loading: false
            };
        }
        default: return state;
    }
};
